import axios from "axios";
import { GetRestaurantTableDto } from "restpay-api-lib/lib/@types/_dtos/getRestaurantTable.dto";
import { RestaurantTableInterface } from "restpay-api-lib/lib/@types/_interfaces/tables/restaurantTable.interface";
import { API_LINKS } from "../constants/links";

export const fetchTableDetailsByTableDto = (
	restaurantTableDto: GetRestaurantTableDto
): Promise<RestaurantTableInterface> => axios.post(`${API_LINKS.FETCH_TABLE_DETAILS}`, restaurantTableDto);
